/* tslint:disable */
/* eslint-disable */
/**
 * Billaan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitializeApplicationRequest
 */
export interface InitializeApplicationRequest {
    /**
     * 
     * @type {number}
     * @memberof InitializeApplicationRequest
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof InitializeApplicationRequest
     */
    time: number;
    /**
     * 
     * @type {string}
     * @memberof InitializeApplicationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InitializeApplicationRequest
     */
    mobile: string;
    /**
     * 
     * @type {string}
     * @memberof InitializeApplicationRequest
     */
    email: string;
}

/**
 * Check if a given object implements the InitializeApplicationRequest interface.
 */
export function instanceOfInitializeApplicationRequest(value: object): value is InitializeApplicationRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mobile' in value) || value['mobile'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function InitializeApplicationRequestFromJSON(json: any): InitializeApplicationRequest {
    return InitializeApplicationRequestFromJSONTyped(json, false);
}

export function InitializeApplicationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitializeApplicationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'time': json['time'],
        'name': json['name'],
        'mobile': json['mobile'],
        'email': json['email'],
    };
}

export function InitializeApplicationRequestToJSON(json: any): InitializeApplicationRequest {
    return InitializeApplicationRequestToJSONTyped(json, false);
}

export function InitializeApplicationRequestToJSONTyped(value?: InitializeApplicationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'time': value['time'],
        'name': value['name'],
        'mobile': value['mobile'],
        'email': value['email'],
    };
}

